
import { api } from "./httpClient";

/**
 * Generyczne pobranie pliku (blob) GETem.
 * @param {string} path
 * @param {Object} [params]
 * @param {AbortSignal} [signal]
 * @param {(progressEvent: ProgressEvent) => void} [onDownloadProgress]
 */
export function getFileBlob(path, params, signal, onDownloadProgress) {
  return api.get(path, {
    params,
    responseType: "blob",
    signal,
    onDownloadProgress,
  });
}
